import Vue from 'vue'
import axios from 'axios';

//console.log(Vue.config.devtools);
//console.log(process.env.NODE_ENV);

const url = process.env.VUE_APP_API_URL;

const headers = {
    headers: {
        'Content-Type': 'application/json'
    }
};
export default {
    signIn(credentials) {
        return axios
            .post(url + 'sign-in/', credentials, headers)
            .then(response => response.data)
            .catch((e) => {
                console.error(e);
                if (e.response) return e.response.data;
                return { status: 'error', msg: 'Network error' };
            });
    },
    newPw(credentials) {
        return axios
            .post(url + 'pw-help/', credentials, headers)
            .then(response => response.data)
            .catch((e) => {
                console.error(e);
                if (e.response) return e.response.data;
                return { status: 'error', msg: 'Network error' };
            });
    },
    setNewPassword(credentials) {
        return axios
            .post(url + 'set-new-password/', credentials, headers)
            .then(response => response.data);
    },
    verifyTotp(credentials) {
        return axios
            .post(url + 'totp-verify-login/', credentials, headers)
            .then(response => response.data)
            .catch((e) => {
                console.error(e);
                if (e.response) return e.response.data;
                return { status: 'error', msg: 'Network error' };
            });
    }
};